import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import AppLayout from "../layouts/AppLayout";
import Home from "../views/Home";
import Menu from "../views/Menu";
import OrderConfirm from "../views/OrderConfirm";
import PaymentWindow from "../views/PaymentWindow";
import MyOrder from "../views/MyOrder";
import Main from "../dashboard/Locations/Main";
import EditTodo from "../dashboard/Locations/EditTodo";
import MainCategories from "../dashboard/barCategories/Main";
import EditCategories from "../dashboard/barCategories/EditTodo";
import MainItems from "../dashboard/Items-dashboard/Main";
import EditItems from "../dashboard/Items-dashboard/EditTodo";
import MainIngredients from "../dashboard/Ingredients-dashboard/Main";
import EditIngredients from "../dashboard/Ingredients-dashboard/EditTodo";

import MainExtras from "../dashboard/Extras-dashboard/Main";
import EditExtras from "../dashboard/Extras-dashboard/EditTodo";

import MainBanners from "../dashboard/Banners-dashboard/Main";
import MainWait from "../dashboard/Waitingtime-dashboard/Main";
import MainBusinessHr from "../dashboard/DateNTime-dashboard/Main";

import MainTip from "../dashboard/Tip-dashboard/Main";
import EditTip from "../dashboard/Tip-dashboard/EditTodo";

import MainSpecialdeals from "../dashboard/Specialdeals-dashboard/Main";

const ContainerRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => <Component {...props} />} />
);

class AppRoute extends Component {
  state = {};
  render() {
    return (
      <AppLayout>
        <Switch>
          <Route exact path="/">
            <Redirect to="/home" />
          </Route>
          <ContainerRoute exact path="/home" component={Home} />
          <ContainerRoute exact path="/menu" component={Menu} />
          <ContainerRoute exact path="/orderconfirm" component={OrderConfirm} />
          <ContainerRoute exact path="/payment" component={PaymentWindow} />
          <ContainerRoute exact path="/myorder" component={MyOrder} />
          <ContainerRoute exact path="/dashboard/locations" component={Main} />

          <ContainerRoute
            exact
            path="/dashboard/locations/:id"
            component={EditTodo}
          />

          <ContainerRoute
            exact
            path="/dashboard/categories"
            component={MainCategories}
          />
          <ContainerRoute
            exact
            path="/dashboard/categories/:id"
            component={EditCategories}
          />
          <ContainerRoute exact path="/dashboard/items" component={MainItems} />
          <ContainerRoute
            exact
            path="/dashboard/items/:id"
            component={EditItems}
          />
          <ContainerRoute
            exact
            path="/dashboard/ingredients"
            component={MainIngredients}
          />
          <ContainerRoute
            exact
            path="/dashboard/ingredients/:id"
            component={EditIngredients}
          />

          <ContainerRoute
            exact
            path="/dashboard/extras"
            component={MainExtras}
          />
          <ContainerRoute
            exact
            path="/dashboard/extras/:id"
            component={EditExtras}
          />
          <ContainerRoute
            exact
            path="/dashboard/banners"
            component={MainBanners}
          />
          <ContainerRoute
            exact
            path="/dashboard/waittime"
            component={MainWait}
          />

          <ContainerRoute
            exact
            path="/dashboard/businesshours"
            component={MainBusinessHr}
          />

          <ContainerRoute exact path="/dashboard/tips" component={MainTip} />
          <ContainerRoute
            exact
            path="/dashboard/tips/:id"
            component={EditTip}
          />
          <ContainerRoute
            exact
            path="/dashboard/specialdeal"
            component={MainSpecialdeals}
          />

          <Redirect from="*" to="/not-found" />
        </Switch>
      </AppLayout>
    );
  }
}

export default AppRoute;
